import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalService } from '../modal.service';
import $ from 'jquery';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent implements OnInit {

  @ViewChild('confirmModal', { static: false }) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-sm',
    ignoreBackdropClick: true,
    keyboard: false,
    animated: false,
    backdrop: true // Ensure backdrop is shown
  };

  callback: Function;
  title: any = '';
  content: any = '';
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.modalServ.onConfirm.subscribe(req => {
      this.title = '';
      this.content = '';
      this.title = req.title;
      this.content = req.content;
      this.callback = req.callback;
      this.show();
    });

    this.modalServ.onConfirmHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if (this.modalRef) {
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  confirm(): void {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.isShow = false;
    this.callback({ status: 'confirm' });
  }

}
